import { ArrowUpRight, Lock, ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n";
import { scrollToHash } from "./Navbar";

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-brand-900 text-white" data-testid="main-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-10 lg:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <div className="flex items-center">
              <span className="inline-flex rounded-xl bg-white px-3 py-2">
                <img src="/assets/electro-logo.png" alt="electro.technology" className="h-8 w-auto" />
              </span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
              {t.footer.group} —{" "}
              <a data-testid="footer-arthurtoren-link" href="https://arthurtoren.co.uk" target="_blank" rel="noopener noreferrer" className="underline decoration-brand-500/50 underline-offset-4 transition-colors hover:text-brand-400">arthurtoren.co.uk</a>
              {" · "}
              <a data-testid="footer-path-link" href="https://path.com.pl" target="_blank" rel="noopener noreferrer" className="underline decoration-brand-500/50 underline-offset-4 transition-colors hover:text-brand-400">path.com.pl</a>
              {" · "}
              <a data-testid="footer-hadron-link" href="https://hadronenergy.pl" target="_blank" rel="noopener noreferrer" className="underline decoration-brand-500/50 underline-offset-4 transition-colors hover:text-brand-400">hadronenergy.pl</a>
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[11px] tracking-[0.25em] text-brand-400">{t.footer.products}</div>
            <ul className="mt-4 space-y-2.5 text-sm text-white/70">
              <li><a data-testid="footer-amperi-link" href="https://amperi.eu/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 transition-colors hover:text-brand-400">amperi.eu <ArrowUpRight size={12} /></a></li>
              <li><a data-testid="footer-margtor-link" href="https://margtor.africa" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 transition-colors hover:text-brand-400">margtor.africa — {t.footer.africa} <ArrowUpRight size={12} /></a></li>
              <li><a data-testid="footer-youtube-link" href="https://youtube.com/playlist?list=PLjG2JQx9YDFYBsxQQuPxayvvboXaNL2AI" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 transition-colors hover:text-brand-400">Julia Amperi — mini series <ArrowUpRight size={12} /></a></li>
              <li className="text-white/50">BatMat · dostava · eFun · Tiger</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[11px] tracking-[0.25em] text-brand-400">{t.footer.contact}</div>
            <ul className="mt-4 space-y-2.5 text-sm text-white/70">
              <li>Jasnogórska 1, 31-358 Kraków, POLAND</li>
              <li><a href="mailto:kontakt@amperi.eu" className="transition-colors hover:text-brand-400">kontakt@amperi.eu</a></li>
              <li><a href="tel:+48888822112" className="transition-colors hover:text-brand-400">+48 8888 22 112</a></li>
              <li><a data-testid="footer-phone-2" href="tel:+48123964554" className="transition-colors hover:text-brand-400">+48 12 396 45 54</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <button
              data-testid="back-to-top-button"
              onClick={scrollToHash("#top")}
              className="inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-2.5 text-xs font-semibold transition-colors duration-300 hover:border-brand-400 hover:text-brand-400"
            >
              <ArrowUp size={14} /> Top
            </button>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-7 text-xs text-white/45 sm:flex-row sm:items-center sm:justify-between">
          <span data-testid="footer-copyright">© 2026 electro.technology sp. z o. o. — {t.footer.rights}</span>
          <span className="font-mono">EU VAT: PL6751713117 · KRS: 0000802135 · REGON: 384286361 · BDO: 000598843</span>
          <Link to="/admin" data-testid="footer-admin-link" className="inline-flex items-center gap-1.5 transition-colors hover:text-brand-400">
            <Lock size={12} /> Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};
